import { gql } from 'apollo-angular';

export const ACTIVE_PREQUALIFICATION_WINDOW_GRAPHQL = gql`
  query GetActivePrequalificationWindow {
    getActivePrequalificationWindow {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        agoMt
        cargosPerMonthMax
        cargosPerMonthMin
        closingDate
        combiDarMtwaraAgoPmsMt
        combiTangaAgoPmsMt
        createdAt
        description
        financialYearUuid
        id
        ikAndJetMt
        manualYear
        monthlyVolume
        openingDate
        participationYear
        pmsMt
        prequalificationNo
        prequalificationYear
        resultsDate
        status
        title
        type
        uuid
        checklist {
          active
          checkListDescription
          checkListName
          createdAt
          id
          uuid
          sections {
            active
            createdAt
            id
            secName
            secNumber
            sequenceNumber
            updatedAt
            updatedBy
            uuid
            criterias {
              active
              attachmentRequired
              createdAt
              criteriaNumber
              description
              forInt
              forJv
              forOmc
              id
              sequenceNumber
              uuid
              children {
                active
                attachmentRequired
                createdAt
                criteriaNumber
                description
                forInt
                forJv
                forOmc
                id
                sequenceNumber
                updatedAt
                updatedBy
                uuid
                attachmentType {
                  active
                  fileType
                  id
                  kind
                  name
                  uuid
                }
                children {
                  active
                  attachmentRequired
                  createdAt
                  criteriaNumber
                  description
                  forInt
                  forJv
                  forOmc
                  id
                  sequenceNumber
                  uuid
                  attachmentType {
                    active
                    fileType
                    id
                    kind
                    name
                    uuid
                  }
                  children {
                    active
                    attachmentRequired
                    createdAt
                    criteriaNumber
                    description
                    forInt
                    forJv
                    forOmc
                    id
                    sequenceNumber
                    uuid
                  }
                }
              }
              attachmentType {
                active
                createdAt
                fileType
                id
                kind
                name
                uuid
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PREQUALIFICATION_PDF_GRAPHQL = gql`
  query GetPrequalificationWidowNoticePdf($uuid: String!) {
    getPrequalificationWidowNoticePdf(uuid: $uuid) {
      code
      data
      dataList
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const ENROLL_PREQUALIFICATION_GRAPHQL = gql`
  mutation EnrollToPrequalification($qualificationUuid: String!) {
    enrollToPrequalification(qualificationUuid: $qualificationUuid) {
      code
      data {
        active
        id
        preQualificationExpiryDate
        status
        uuid
        bills {
          billDate
          billNumber
          billStatus
          clientName
          clientPhoneNumber
          controlNumber
          currency
          description
          id
          totalAmountAfterTax
          uuid
        }
        company {
          active
          addressDescription
          attachableDiscriminator
          brelaDataFetched
          brelaFetchedAt
          brelaRegistrationNumber
          bucketName
          companyType
          countryUuid
          districtId
          id
          name
          otherAttachmentName
          postalCode
          registrationCompletedAt
          registrationStatus
          registrationType
          taxPayerCenter
          taxPayerName
          taxPayerRegion
          taxPayerRegistrationDate
          taxpayerNumber
          tin
          tinOrTaxpayerNumber
          uuid
          website
        }
        supplier {
          active
          id
          name
          uuid
        }
        window {
          active
          agoMt
          cargosPerMonthMax
          cargosPerMonthMin
          closingDate
          combiDarMtwaraAgoPmsMt
          combiTangaAgoPmsMt
          createdAt
          description
          financialYearUuid
          id
          ikAndJetMt
          manualYear
          monthlyVolume
          openingDate
          participationYear
          pmsMt
          prequalificationNo
          prequalificationYear
          resultsDate
          status
          title
          type
          uuid
        }
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GET_PREQUALIFICATION_BY_CURRENT_WINDOW_GRAPHQL = gql`
  mutation GetSupplierPrequalificationByCurrentWindow {
    getSupplierPrequalificationByCurrentWindow {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        id
        preQualificationExpiryDate
        status
        uuid
        bills {
          billDate
          billNumber
          billStatus
          clientName
          clientPhoneNumber
          controlNumber
          currency
          description
          id
          totalAmountAfterTax
          uuid
          itemList {
            collectionCenter
            collectionCenterId
            description
            gfsCode
            id
            isExempted
            quantity
            taxAmount
            totalAmount
            unitPrice
            billItemDetails {
              details
              id
              quantification
              taxAmount
              totalAmount
              unitPrice
            }
          }
          receipts {
            amount
            currency
            paymentDate
            receiptNo
            transactionId
            uuid
          }
        }
        checklistItems {
          active
          attachableDiscriminator
          attachmentUploaded
          bucketName
          checklistEvaluation
          id
          otherAttachmentName
          registrationType
          supplierComments
          uuid
          attachments {
            active
            id
            minioObjectName
            otherAttachmentName
            uuid
            attachable {
              attachableDiscriminator
              bucketName
              id
              otherAttachmentName
              registrationType
              uuid
            }
            attachmentType {
              active
              fileType
              id
              kind
              name
              uuid
            }
          }
          checklistCriteria {
            active
            attachmentRequired
            criteriaNumber
            description
            forInt
            forJv
            forOmc
            id
            sequenceNumber
            uuid
            attachmentType {
              active
              fileType
              id
              kind
              name
              uuid
            }
            children {
              active
              attachmentRequired
              criteriaNumber
              description
              forInt
              forJv
              forOmc
              id
              sequenceNumber
              uuid
              attachmentType {
                active
                fileType
                id
                kind
                name
                uuid
              }
            }
            parent {
              active
              attachmentRequired
              criteriaNumber
              description
              forInt
              forJv
              forOmc
              id
              sequenceNumber
              uuid
              attachmentType {
                active
                fileType
                id
                kind
                name
                uuid
              }
            }
          }
        }
        company {
          active
          addressDescription
          brelaRegistrationNumber
          id
          isJointVenture
          name
          taxpayerNumber
          tin
          tinOrTaxpayerNumber
          website
        }
        supplier {
          active
          id
          name
          uuid
        }
      }
    }
  }
`;

export const ATTEND_SUPPLIER_CHECKLIST_ITEM_GRAPHQL = gql`
  mutation AttendSupplierCheckListItem($attendCheckListItemDtoInput: CheckListAttendDtoInput!) {
    attendSupplierCheckListItem(item: $attendCheckListItemDtoInput) {
      code
      data {
        active
        attachableDiscriminator
        attachmentUploaded
        bucketName
        checklistEvaluation
        createdAt
        evaluatedByName
        evaluationRemarks
        id
        otherAttachmentName
        registrationType
        supplierComments
        uuid
        attachments {
          active
          id
          minioObjectName
          otherAttachmentName
          updatedAt
          updatedBy
          uuid
          attachable {
            attachableDiscriminator
            bucketName
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            fileType
            id
            kind
            name
            updatedAt
            uuid
          }
        }
        checklistCriteria {
          active
          attachmentRequired
          criteriaNumber
          description
          forInt
          forJv
          forOmc
          id
          sequenceNumber
          uuid
          parent {
            active
            attachmentRequired
            criteriaNumber
            deleted
            description
            description
            forInt
            forJv
            forOmc
            id
            sequenceNumber
            updatedAt
            updatedBy
            uuid
            attachmentType {
              active
              fileType
              id
              kind
              name
              uuid
            }
          }
        }
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SUBMIT_SUPPLIER_PREQUALIFICATION_GRAPHQL = gql`
  mutation SubmitSupplierPrequalification($preQualificationUuid: String!) {
    submitSupplierPrequalification(preQualificationUuid: $preQualificationUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        preQualificationExpiryDate
        status
        uuid
      }
    }
  }
`;

const ATTACHMENT_TYPE_FIELDS = gql`
  fragment AttachmentTypeFields on AttachmentType {
    id
    uuid
    name
    kind
    fileType
    active
  }
`;

const CHECKLIST_CRITERIA_FIELDS = gql`
  fragment ChecklistCriteriaFields on ChecklistCriteria {
    id
    uuid
    criteriaNumber
    sequenceNumber
    description
    attachmentRequired
    forInt
    forJv
    forOmc
    active
    attachmentType {
      ...AttachmentTypeFields
    }
  }
  ${ATTACHMENT_TYPE_FIELDS}
`;

export const GET_SUPPLIER_PREQUALIFICATION_BY_UUID_GRAPHQL = gql`
  query GetSupplierPreQualificationByUuid($uuid: String!) {
    getSupplierPreQualificationByUuid(uuid: $uuid) {
      status
      code
      message
      fieldsErrors
      extras
      data {
        id
        uuid
        active
        status
        canResubmit
        identifiedShortfalls
        finalEvaluationRemark
        preQualificationExpiryDate
        company {
          id
          name
          tin
          taxpayerNumber
          tinOrTaxpayerNumber
          brelaRegistrationNumber
          addressDescription
          website
          isJointVenture
          active
        }
        supplier {
          id
          uuid
          name
          active
        }

        bills {
          id
          uuid
          controlNumber
          billNumber
          billDate
          billStatus
          currency
          totalAmountAfterTax
          description
          clientName
          clientPhoneNumber
          itemList {
            id
            description
            gfsCode
            quantity
            unitPrice
            taxAmount
            totalAmount
            isExempted
            collectionCenter
            collectionCenterId
            billItemDetails {
              id
              details
              quantification
              unitPrice
              taxAmount
              totalAmount
            }
          }
          receipts {
            uuid
            receiptNo
            transactionId
            paymentDate
            amount
            currency
          }
        }
        checklistItems {
          id
          uuid
          attachableDiscriminator
          attachmentUploaded
          bucketName
          registrationType
          checklistEvaluation
          evaluationRemarks
          supplierComments
          otherAttachmentName
          active
          attachments {
            id
            uuid
            minioObjectName
            otherAttachmentName
            active
            attachable {
              id
              uuid
              attachableDiscriminator
              bucketName
              registrationType
              otherAttachmentName
            }
            attachmentType {
              ...AttachmentTypeFields
            }
          }
          checklistCriteria {
            ...ChecklistCriteriaFields
            parent {
              ...ChecklistCriteriaFields
            }
            children {
              ...ChecklistCriteriaFields
            }
          }
        }
      }
    }
  }
  ${ATTACHMENT_TYPE_FIELDS}
  ${CHECKLIST_CRITERIA_FIELDS}
`;
